import { useState, useRef, useEffect } from "react";

function parseStepNumber() {
  return parseInt(window.location.hash.match(/\d+/)?.[0] || "", 10);
}

/**
 * This hook is used to keep track of the current step in the URL hash.
 */
export function useLocationStep(): [
  number,
  number,
  (step: number) => void,
  (step: number) => void,
] {
  const [[step, direction], setStep] = useState([parseStepNumber(), 1]);
  const prevStep = useRef(step);

  const handleHashChange = () => {
    const nextStep = parseStepNumber();
    setStep([nextStep, nextStep > prevStep.current ? 1 : -1]);
    prevStep.current = nextStep;
  };

  useEffect(() => {
    window.addEventListener("hashchange", handleHashChange);
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return [
    step,
    direction,
    function push(step: number) {
      window.location.hash = `/${step}`;
    },
    function replace(step: number) {
      window.history.replaceState(
        null,
        "",
        `${window.location.pathname}${window.location.search}#/${step}`,
      );
      handleHashChange();
    },
  ];
}
